// en

import bi from './bi';
import mka from './mka';
import segment from './segment';
import component from './component';
import communication from './communication';
import authentication from './authentication';
import myAccount from './my-account';
import notification from './notification';
import permission from './permission';
import dataRelation from './data-relation';
import dataConnector from './data_connector';

export default {
  color_swatches: 'Color Swatches',
  simple: 'Simple',
  custom: 'Custom',
  advance: 'Advance',
  shade: 'Shade',
  random: 'Random',
  clear_all: 'Clear All',

  time_picker: {
    select_time: 'Select Time',
  },

  date_picker: {
    relative: {
      // -- duration
      day: '{days} Day | {days} Days',
      month: '{months} Month | {months} Months',
      year: '{years} Year | {years} Years',
      hour: '{hours} Hour | {hours} Hours',
      minute: '{minutes} Minute | {minutes} Minutes',
      second: '{seconds} Second | {seconds} Seconds',
      // --- relative
      today: 'Today',
      // --- custom
      custom: 'Custom',
    },
    to: 'To',
    date_range: 'Date Range',
    select_date: 'Select Date',
    start_date: 'Start Date',
    end_date: 'End Date',
    apply: 'Apply',
    cancel: 'Cancel',
    relative_picker: 'Relative Picker',
    last_day: 'Last {num} Days',
    last_month: 'Last {num} Months',
    last_year: 'Last {num} Years',
    last_hour: 'Last {num} Hours',
    last_minute: 'Last {num} Minutes',
    last_second: 'Last {num} Seconds',
  },

  Segment: 'Segment',
  Communication: 'Communication',
  Channel: 'Channel',
  'Line OA': 'LINE',
  Campaign: 'Campaign',
  campaign_list: 'Campaign List',
  edit_campaign: 'Edit Campaign',
  Create: 'Create',
  campaign_info: 'Campaign Info',

  auth: {
    btn_login: 'login',
    username: 'username',
    email_required: 'email is required',
    username_required: 'username is required',
    username_invalid: 'username is invalid',
    password: 'password',
    password_required: 'password is required',
    password_invalid: 'password is invalid',
  },

  main_menu: {
    dashboard: 'Dashboard',
    segment: 'Segment',
    data_connector: 'Data Connector',
    data_cconnector_overview: 'Data Source',
    data_connector_data_relationship: 'Data Relationship',
    data_connector_coupon: 'Coupon',
    data_connector_history: 'History',
    communication: 'Communication',
    communication_all_channel: 'All Channel',
    communication_limitation: 'Limitation',
    automation: 'Marketing Automation',
    setting: 'Setting',
  },

  menu_bar: {
    edit_profile: 'Edit Profile',
    brand_account: 'Brand Account',
    change_brand_account: 'Change Brand Account',
    permission: 'Permission',
    profile: 'Profile',
    manage_permission: 'Manage Permission',
    history: 'History',
    change_role: 'Change Role',
    manage_storage: 'Manage Storage',
    configuration: 'Configuration',
    sign_out: 'Sign Out',
    change_password: 'Change Password',
    switchlanguage: 'Language',
  },

  change_brand_modal: {
    error: 'Something went wrong',
    error_description: 'Brand cannot be selected at this time',
    change_brand_account: 'Change Brand Account',
    select_brand_account: 'Select Brand Account',
    cancel: 'Cancel',
    change: 'Change',
  },

  bi,

  data_connector: {
    // Tab
    tab_data_connector: 'Data Connector',
    tab_data_source_list: 'Data Link',
    tab_add_datasource: 'Add Data Source',
    tab_excel_datasource: 'Excel Data Source',
    tab_file_history: 'Excel File History',
    tab_Setting_fasthelp5_Integration: 'Setting fasthelp5 Integration',
    // Page overview
    overview_title: 'The Management tools for data import and export.',
    overview_btn_connect_datasource: 'Data Source',
    overview_data_connector_detail: 'You can now connect the data sources you want to send data to.',
    overview_btn_connect_commu: 'Destination',
    overview_commu_detail: 'Now you can connect the Destinations your want to send data to.',
    // Page file history
    file_history_column_no: 'No.',
    file_history_column_ref_code: 'Ref.Code',
    file_history_column_type: 'Template Type',
    file_history_column_name: 'Name',
    file_history_column_amount: 'Upload File',
    file_history_column_last_update: 'Last Update',
    file_history_column_status: 'Status',
    // Page datasource
    datasource_header: 'Add Data Source',
    datasource_search_text: 'search',
    // Page dataset
    dataset_btn_create_template: 'Create',
    // Page create template
    // Page update file
    upload_file_progress_upload: 'Upload File',
    upload_file_progress_confirm_data: 'Confirm Data',
    upload_title_download_template: 'Download Template',
    upload_btn_download_template: 'Download Template',
    upload_btn_browse_file: 'Browse File',
    upload_backup_file: 'Backup file',
    // Page summary upload
    summary_upload_column_status: 'Status',
    summary_upload_column_quantity: 'Quantity',
    summary_upload_column_row_success: 'Success',
    summary_upload_column_row_error: 'Error',
    summary_upload_column_row_total: 'All',
    // Page coupon managements
    tab_coupon_management: 'Coupon',
    tab_coupon_detail: 'Detail',
    upload_coupon_button: 'Upload Coupon',
    edit_coupon_button: 'Edit Detail',
    status_coupon_text: 'Status',
    // Table coupon
    couponId: 'couponId',
    image: 'Image',
    campaignName: 'Campaign Name',
    couponType: 'Coupon Type',
    trackingCode: 'Tracking Code',
    source: 'Source',
    format: 'Format',
    balanceandtotal: 'Balance/Total',
    balance: 'Balance',
    total: 'Total',
    reference: 'Reference',
    lastUpload: 'Last Upload',
    updateBy: 'Update by',
    status: 'Status',
    lastUpdate: 'Last Update',
    action_edit: 'action edit',
  },

  setting: {
    unauthorized: 'Unauthorized',
    detail_setting: '"You need permission to perform this action" on Choco CDP.',
    cell_us: 'Cell us',
    contact: 'Contact',
  },

  base_table: {
    noItems: 'No Items',
    loading: 'Loading',
  },
  global: {
    view_more: 'View More',
    loading: 'Loading...',
    export: 'Export',
    cancel: 'Cancel',
    apply: 'Apply',
    close: 'Close',
    confirm: 'Confirm',
    filter: 'Filter',
    save: 'Save',
    edit: 'Edit',
    copy: 'Copy',
    delete: 'Delete',
    no_information: 'No information',
    error: 'An error occurred.',
    back: 'Back',
    not_dowload_report: "Don't Download Report",
    confirm_delete: 'Confirm Delete',
    do_confirm_delete: 'Do you want delete {any}',
    confirm_duplicate: 'Confirm Duplicate',
    do_confirm_duplicate: 'Do you want duplicate {any}',
    confirm_cancel: 'Confirm Cancel',
    do_confirm_cancel: 'Do you want Cancel {any}',
  },

  component: component,
  segment: segment,
  mka: mka,
  communication: communication,
  authentication: authentication,
  account: myAccount,
  notification: notification,
  permission: permission,
  dataRelation: dataRelation,
  dc: dataConnector,
  // Churn Rate​
  churn_rate: 'Churn Rate​',
  all_segment: 'All Segment​',
  overview: 'Overview​',
  data_source: 'Data Source​',
  calculate_churn_rate: 'calculate Churn Rate​​',
  overall_churn_rate: 'Overall Churn Rate',
  des_overall_churn_rate:
    'Customer churn rate is the proportion of total customers who cease using a company products or services within a specified time frame.',
  select_segment: 'Select Segment',
  stage: 'Stage',
  normal: 'Normal',
  risk_churn: 'Risk Churn',
  churn: 'Churn',
};
